module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/gatsby/~/core-js/modules/_perform.js
// module id = 248
// module chunks = 168707334958949